module.exports = __webpack_public_path__ + "img/helmet_visitor.00340450.png";